export default __webpack_public_path__ + "static/media/twenty.4b045d54.png";